import { render, staticRenderFns } from "./DissolutionView.vue?vue&type=template&id=2cca3f76&"
import script from "./DissolutionView.vue?vue&type=script&lang=js&"
export * from "./DissolutionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports